import {useFormikContext} from 'formik';
import {__} from "@wordpress/i18n";
import AlertIcon from "../../../../assets/media/svg/icons/alert-filled.svg"

const CustomErrorExpenses = () => {
  const {errors} = useFormikContext<any>();

  return Object.keys(errors).length > 0 ?

      <div className={"custom-error-message mb-5"}>
        <AlertIcon/>
        <div>
          <h6
            className="typo-heading--8 font-bold text-yellow-120 mb-1">{__("Quase pronto! Só falta uma despesa", "df-simulators")}</h6>
          <h6
            className="typo-heading--8 font-bold">{__("Por favor, insira pelo menos uma despesa para calcular a sua taxa de esforço.", "df-simulators")}</h6>
        </div>
      </div>
     : <></>;
};

export default CustomErrorExpenses;
